import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useSelector } from 'react-redux';
import { StyledSetting } from './index.style';
import tabComponents from './tabComponents';

const Settings = () => {
  const { account } = useSelector((state) => state.auth);
  const userRoles = account?.roles || [];
  // Filter accessible tabs once, outside of useState
  const accessibleTabs = tabComponents.filter((tab) =>
    tab.role.some((role) => userRoles.includes(role)),
  );

  const [activeTab, setActiveTab] = useState(() => {
    const initialTab = accessibleTabs[0]?.value || '';
    return initialTab;
  });

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <StyledSetting>
      <Box sx={{ width: '100%' }}>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          {accessibleTabs.map((tab) => (
            <Tab value={tab.value} label={tab.label} />
          ))}
        </Tabs>
      </Box>

      {accessibleTabs.map((tab) =>
        activeTab === tab.value ? <tab.component key={tab.value} /> : null,
      )}
    </StyledSetting>
  );
};

export default Settings;
